<template>
	<div class="creation-wizard-list-item-row flex-1 display-flex flex-wrap width-100 height-100">
		<div class="icon-box display-flex flex-align-center pr-2">
			<slot name="icon" v-bind:icon="icon">
				<AppIcon :name="icon" height="20" width="20" />
			</slot>
		</div>
		<div class="flex-1 display-flex flex-align-center pl-3 flex-wrap">
			<div :class="{ 'align-self-flex-end flex-col-12': descriptionInNewLine }">
				<slot name="title" v-bind:title="title">
					<h4 class="reg">{{ title }}</h4>
				</slot>
			</div>
			<div :class="[descriptionInNewLine ? 'align-self-flex-start flex-col-12' : 'pl-2']">
				<slot name="description" v-bind:description="description">
					<h4 class="description">{{ description }}</h4>
				</slot>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'CreationWizardListItemRow',
	props: {
		icon: { type: String },
		title: { type: String },
		description: { type: String },
		descriptionInNewLine: { type: Boolean },
	},
};
</script>

<style lang="scss" scoped>
.icon-box {
	border-right: 1px solid var(--button-border);
}
.creation-wizard-list-item-row {
	.hover-area {
		background: white;
		display: none;
		opacity: 0;
	}
	&:hover {
		.hover-area {
			display: flex;
			opacity: 1;
		}
	}
}
h4.description {
	color: #474647;
	opacity: 0.5;
}
</style>
